import React from 'react';
import AInput from '../../../../common/formFeilds/customInput/AInput';
import { Col, Row } from 'reactstrap';
import { inputStyles, labelStyles } from '../utils';

const TestDetails = ({
    resultInfo
}) => {

    const fields = [
        { label: 'Serial No', value: 'aesSno' },
        { label: 'Test Code', value: 'examTimeCode' },
        { label: 'Test rec ID', value: 'aesTestRecId' },
        { label: 'Test Date', value: 'testDate' },
        { label: 'Test Name', value: 'aesMasterName' },
        { label: 'Course', value: 'courseTitleLong' },
    ]

    return (
        <>
            <h3 className='mt-2 mb-0'>Test Details</h3>
            <Row>
                {fields?.map((field, idx) =>
                    <Col md="4" key={idx}>
                        <AInput
                            labelStyle={labelStyles}
                            style={inputStyles}
                            label={field?.label}
                            value={resultInfo?.[field?.value]}
                            disabled
                        />
                    </Col>
                )}
            </Row>
        </>
    );
}

export default TestDetails;